import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { CreateDefectNotice } from '../../../common/validations/defectNotice'
import {
  CreateDefectNoticeResponseBody,
  CreateDefectNoticeResponseBodySchema,
} from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { ResidentAppError } from '../../../common/error'
import { ErrorResponse } from '../../../common/validations'

import { post } from 'api/apiClient'
import { throwOnAccessDenied } from 'api/throwOnAccessDenied'

export const useAPIPostDefectNotice = (
  options?: UseMutationOptions<
    CreateDefectNoticeResponseBody,
    ErrorResponse,
    CreateDefectNotice
  >
) => {
  const { isError, isPending, mutate } = useMutation({
    mutationFn: (data) =>
      post(
        API_ENDPOINTS.CREATE_DEFECT_NOTICE,
        data,
        CreateDefectNoticeResponseBodySchema
      ),
    retry: 1,
    throwOnError: throwOnAccessDenied,
    ...options,
  })

  if (isError) {
    throw ResidentAppError.ClientError('DEFECT_NOTICE_SUBMIT_ERROR')
  }

  return {
    submit: mutate,
    isSubmitting: isPending,
  }
}
